import { Info } from '@mui/icons-material';
import { Box, Tooltip } from '@mui/material';
import { IProject } from '../../core/interfaces/project.interface';

export const FAILED_TOOLTIP = 'Someone from our team will be in touch within 1 working day.';

/**
 * Whether a project's True Sight order failed. `failedAt` is written by the result callback or the
 * BFF; the live progress stream may say so first, before the project list has been reloaded. A
 * result always wins, so a project re-run after a failure shows its result.
 */
export const isProjectFailed = (
  project: IProject,
  progress?: { status?: string; statusUrl?: string } | null,
): boolean => {
  if (project.hasResult) return false;
  if (project.failedAt) return true;

  const progressUuid = progress?.statusUrl?.split('/').pop();
  return progress?.status === 'failed' && progressUuid === project._id;
};

export interface FailedStatusProps {
  variant?: 'body' | 'inline';
}

/** "Failed" with the same info-icon tooltip "Pending" uses, telling the customer we will follow up. */
export const FailedStatus: React.FC<FailedStatusProps> = ({ variant = 'inline' }) => (
  <Box
    component="span"
    sx={{
      display: 'inline-flex',
      alignItems: 'center',
      color: 'error.main',
      padding: variant === 'body' ? '8px' : 0,
    }}
  >
    Failed
    <Tooltip title={FAILED_TOOLTIP}>
      <Info sx={{ fontSize: '16px', color: 'gray', ml: 0.5 }} aria-label={FAILED_TOOLTIP} />
    </Tooltip>
  </Box>
);
